import { Component,HostListener,  QueryList, ViewChildren } from '@angular/core';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { Observable } from 'rxjs';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { Router } from '@angular/router';
import { Utils } from '../../../../shared/utils/Utils';
const Swal = require("sweetalert2");
import * as data from '../../../../shared/data/dashboard/social'
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import * as XLSX from 'xlsx';

interface PropietarioCumpleanos {
  cedula: string | number;
  primernombre?: string | null;
  segundonombre?: string | null;
  papellidos?: string | null;
  seapellidos?: string | null;
  fechanace?: string | Date | null;
  diaNacimiento?: number | string;
  mesNacimiento?: string;
  edad?: number | null;
}

type EstadoCumpleanos = 'HOY' | 'MANANA' | 'PROXIMO' | 'PROGRAMADO';
type ColumnaOrden = 'cedula' | 'primernombre' | 'fechanace' | 'edad';

@Component({
  selector: 'app-cumpleanos',
  templateUrl: './cumpleanos.component.html',
  styleUrls: ['./cumpleanos.component.scss']
})
export class CumpleanosComponent {
  public facebook = data.facebook;
  public selected = [];

  public searchText = ''; // Texto para búsqueda
  total$!: Observable<number>; // Observable para obtener el total de elementos
  propietarios: any[] = [];
  filteredTableItems: any[] = [];
  propietariosCumpleanios: any[] = [];

  chartLabels: string[] = [];
  chartData: number[] = [];

  conteoPorMes: Record<string, number> = {};
  loading: boolean = false;
  

  public show : boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = 'proximo';
  sortDirection: 'asc' | 'desc' = 'asc';
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  estadoSeleccionado = 'TODOS';
  mesSeleccionado = 0; // Valor por defecto para el filtro de mes
  resumen = {
    hoy: 0,
    manana: 0,
    mes: 0,
    total: 0
  };

  readonly meses = [
    { valor: 1, nombre: 'Enero' },
    { valor: 2, nombre: 'Febrero' },
    { valor: 3, nombre: 'Marzo' },
    { valor: 4, nombre: 'Abril' },
    { valor: 5, nombre: 'Mayo' },
    { valor: 6, nombre: 'Junio' },
    { valor: 7, nombre: 'Julio' },
    { valor: 8, nombre: 'Agosto' },
    { valor: 9, nombre: 'Septiembre' },
    { valor: 10, nombre: 'Octubre' },
    { valor: 11, nombre: 'Noviembre' },
    { valor: 12, nombre: 'Diciembre' }
  ];
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>; // Para la cabecera de la tabla

  tableItem$: any;


  constructor(private propietarioService: PropietarioService,private router: Router ) {}

  ngOnInit() {

    this.listarCumpleaños();
    
  }

  pageSize: number = 10; 
  page: number = 1;
  totalItems!: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
   // this.service.sortColumn = column;
   // this.service.sortDirection = direction;
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      // Si ya estamos ordenando por esta columna, cambiar la dirección
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Si es una nueva columna, ordenar en orden ascendente
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.propietarios.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      // Comparar los valores (ajusta la lógica según el tipo de dato)
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }
  get filteredPropietarios() {
    if (!this.searchTerm) {
      return this.propietarios; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.propietarios.filter(propietario => {
      // Ajusta los campos por los que quieres buscar
      return (
        propietario.primernombre.toLowerCase().includes(term) ||
        propietario.segundonombre.toLowerCase().includes(term) ||
        propietario.papellidos.toLowerCase().includes(term) ||
        propietario.seapellidos.toLowerCase().includes(term) ||
        propietario.cedula.toLowerCase().includes(term) ||
        propietario.mail.toLowerCase().includes(term) ||
        propietario.numerolic.toLowerCase().includes(term) ||
        propietario.direccion.toLowerCase().includes(term) ||
        propietario.cargoData.cargos.toLowerCase().includes(term) ||
        propietario.condicionLaboral.label.toLowerCase().includes(term) ||
        propietario.telfijo.toLowerCase().includes(term) ||
        propietario.telcel.toLowerCase().includes(term)
      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }

 
listarCumpleaños(): void {
  this.loading = true;

  this.propietarioService.getPropietarios().subscribe({
    next: (data) => {
      const propietarios = data?.propietarios ?? [];

      const meses = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
      ];

      this.propietarios = propietarios.map((prop: any) => {
        const fechaOriginal = prop.fechaNacimiento ?? prop.fechanace;
        const fecha = this.parseFechaNacimiento(fechaOriginal);

        return {
          ...prop,
          fechanace: fecha,
          fechaNacimiento: fecha,
          diaNacimiento: fecha?.getDate() ?? null,
          mesNacimiento: fecha
            ? meses[fecha.getMonth()]
            : '',
          edad: fecha ? this.calcularEdad(fecha) : null
        };
      });

      // Mantener el gráfico mensual que ya utilizas.
      this.conteoPorMes = data?.conteoPorMes ?? {};

      this.chartLabels = meses.map(
        mes => mes.charAt(0).toUpperCase() + mes.slice(1)
      );

      this.chartData = meses.map(
        mes => Number(this.conteoPorMes[mes] ?? 0)
      );

      this.calcularResumen(); 
      // La colección completa se filtra y ordena mediante filterData().
      this.filterData();

      // Mantener la lista de cumpleaños del mes actual si otros métodos
      // de tu componente todavía la utilizan.
      const mesActual = new Date().getMonth();

      this.propietariosCumpleanios = this.propietarios.filter(prop => {
        const fecha = this.parseFechaNacimiento(prop.fechaNacimiento);
        return fecha !== null && fecha.getMonth() === mesActual;
      });

      this.loading = false;
    },
    error: (err) => {
      console.error('Error cargando propietarios', err);
      this.propietarios = [];
      this.filteredTableItems = [];
      this.propietariosCumpleanios = [];

      this.resumen = {
        hoy: 0,
        manana: 0,
        mes: 0,
        total: 0
      };

      this.loading = false;
    }
  });
}


  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
 exportToPDF(tableId:string,nameFile:string,titleFile:string) {
  Utils.exportToPDF(tableId, nameFile,titleFile);
  }


/*   exportarExcel(tableId:string,nameFile:string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  } */
 
    
private parseFechaNacimiento(valor: unknown): Date | null {
  if (!valor) {
    return null;
  }

  if (valor instanceof Date) {
    return this.esFechaValida(valor)
      ? new Date(valor.getFullYear(), valor.getMonth(), valor.getDate())
      : null;
  }

  if (typeof valor === 'string') {
    const texto = valor.trim();

    // Formato YYYY-MM-DD: evita cambios por zona horaria.
    const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);

    if (iso) {
      return this.validarFecha(
        Number(iso[1]),
        Number(iso[2]),
        Number(iso[3])
      );
    }

    // Formato colombiano DD/MM/YYYY.
    const colombiana = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(texto);

    if (colombiana) {
      return this.validarFecha(
        Number(colombiana[3]),
        Number(colombiana[2]),
        Number(colombiana[1])
      );
    }

    const fecha = new Date(texto);

    return this.esFechaValida(fecha)
      ? new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
      : null;
  }

  return null;
}

private validarFecha(
  anio: number,
  mes: number,
  dia: number
): Date | null {
  const fecha = new Date(anio, mes - 1, dia);

  if (
    fecha.getFullYear() !== anio ||
    fecha.getMonth() !== mes - 1 ||
    fecha.getDate() !== dia
  ) {
    return null;
  }

  return fecha;
}

private esFechaValida(fecha: Date): boolean {
  return !Number.isNaN(fecha.getTime());
}

private calcularEdad(fechaNacimiento: Date): number {
  const hoy = new Date();

  let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();

  const faltaCumplir =
    hoy.getMonth() < fechaNacimiento.getMonth() ||
    (
      hoy.getMonth() === fechaNacimiento.getMonth() &&
      hoy.getDate() < fechaNacimiento.getDate()
    );

  if (faltaCumplir) {
    edad--;
  }

  return edad;
}


filterData(): void {
  const searchTextLower = (this.searchText ?? '')
    .toLowerCase()
    .trim();

  this.filteredTableItems = (this.propietarios ?? []).filter(propietario => {
    // Fecha de nacimiento: soporta los dos nombres utilizados en tu API.
    const fechaObj = this.parseFechaNacimiento(
      propietario.fechaNacimiento ?? propietario.fechanace
    );

    // Cédula
    const cedula = String(propietario.cedula ?? '').toLowerCase();

    // Nombre completo
    const nombreCompleto = [
      propietario.primernombre,
      propietario.segundonombre,
      propietario.papellidos,
      propietario.seapellidos
    ]
      .filter(nombre => !!nombre)
      .join(' ')
      .toLowerCase()
      .trim();

    // Día y mes
    const diaNacimiento = fechaObj
      ? String(fechaObj.getDate())
      : '';

    const mesNacimiento = fechaObj
      ? this.meses[fechaObj.getMonth()].nombre.toLowerCase()
      : '';

    const diaMesTexto = `${diaNacimiento} de ${mesNacimiento}`;

    // Fecha completa DD/MM/YYYY
    const fechaCompleta = fechaObj
      ? this.formatearFecha(fechaObj)
      : '';

    // Búsqueda general
    const coincideBusqueda =
      !searchTextLower ||
      cedula.includes(searchTextLower) ||
      nombreCompleto.includes(searchTextLower) ||
      diaNacimiento.includes(searchTextLower) ||
      mesNacimiento.includes(searchTextLower) ||
      diaMesTexto.includes(searchTextLower) ||
      fechaCompleta.includes(searchTextLower);

    // Filtro por mes (0 = todos)
    const coincideMes =
      this.mesSeleccionado === 0 ||
      (
        fechaObj !== null &&
        fechaObj.getMonth() + 1 === Number(this.mesSeleccionado)
      );

    // Filtro por estado
    const estado = this.estadoCumpleanos(propietario);

    const coincideEstado =
      this.estadoSeleccionado === 'TODOS' ||
      (
        this.estadoSeleccionado === 'HOY' &&
        estado === 'HOY'
      ) ||
      (
        this.estadoSeleccionado === 'MANANA' &&
        estado === 'MANANA'
      ) ||
      (
        this.estadoSeleccionado === 'PROXIMO' &&
        ['HOY', 'MANANA', 'PROXIMO'].includes(estado)
      );

    return coincideBusqueda && coincideMes && coincideEstado;
  });

  // Ordena los resultados según la columna seleccionada.
  this.ordenarResultados();

  // Reinicia la paginación después de cada filtro.
  this.page = 1;
}


 // PDF: exporta todos los registros filtrados.
  exportarPDF(): void {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    doc.setFontSize(16);
    doc.text('ADMIN SEAF - Listado de Cumpleaños', 14, 15);

    doc.setFontSize(9);
    doc.text(
      `Fecha de generación: ${this.formatearFecha(new Date())}`,
      14,
      22
    );
    doc.text(
      `Total de registros: ${this.filteredTableItems.length}`,
      14,
      28
    );

    autoTable(doc, {
      startY: 34,
      head: [[
        'Cédula',
        'Empleado',
        'Fecha de nacimiento',
        'Día y mes',
        'Edad',
        'Próximo cumpleaños'
      ]],
      body: this.filteredTableItems.map(persona => [
        String(persona.cedula ?? ''),
        this.nombreCompleto(persona),
        this.fechaNacimiento(persona)
          ? this.formatearFecha(this.fechaNacimiento(persona)!)
          : '',
        this.fechaNacimiento(persona)
          ? this.fechaNacimiento(persona)!.toLocaleDateString('es-CO', {
              day: 'numeric',
              month: 'long'
            })
          : '',
        persona.edad ?? '',
        this.etiquetaEstado(persona)
      ]),
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2
      },
      headStyles: {
        fillColor: [91,91,91],
        textColor: 255
      },
      didDrawPage: () => {
        const alto = doc.internal.pageSize.getHeight();
        const ancho = doc.internal.pageSize.getWidth();

        doc.setFontSize(8);
        doc.text(
          `ADMIN SEAF | Página ${doc.getCurrentPageInfo().pageNumber}`,
          ancho - 14,
          alto - 7,
          { align: 'right' }
        );
      }
    });

    doc.save('Listado_Cumpleanos.pdf');
  }

  private formatearFecha(fecha: Date): string {
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');

    return `${dia}/${mes}/${fecha.getFullYear()}`;
  }

   // Excel: exporta todos los registros filtrados, no solo la página visible.
  exportarExcel(): void {
    const datos = this.filteredTableItems.map(persona => ({
      'Cédula': persona.cedula,
      'Empleado': this.nombreCompleto(persona),
      'Fecha de nacimiento': this.fechaNacimiento(persona)
        ? this.formatearFecha(this.fechaNacimiento(persona)!)
        : '',
      'Día y mes': this.fechaNacimiento(persona)
        ? this.fechaNacimiento(persona)!.toLocaleDateString('es-CO', {
            day: 'numeric',
            month: 'long'
          })
        : '',
      'Edad': persona.cedula ?? '',
      'Próximo cumpleaños': this.etiquetaEstado(persona)
    }));

    const hoja = XLSX.utils.json_to_sheet(datos);
    hoja['!cols'] = [
      { wch: 18 },
      { wch: 35 },
      { wch: 22 },
      { wch: 22 },
      { wch: 12 },
      { wch: 24 }
    ];

    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, 'Cumpleaños');
    XLSX.writeFile(libro, 'Listado_Cumpleanos.xlsx');
  }

   etiquetaEstado(persona: PropietarioCumpleanos): string {
    const dias = this.diasHastaCumpleanos(persona);

    switch (this.estadoCumpleanos(persona)) {
      case 'HOY':
        return '¡HOY!';
      case 'MANANA':
        return 'MAÑANA';
      case 'PROXIMO':
        return `En ${dias} días`;
      default:
        return `En ${dias} días`;
    }
  }
    estadoCumpleanos(persona: PropietarioCumpleanos): EstadoCumpleanos {
    const dias = this.diasHastaCumpleanos(persona);

    if (dias === 0) {
      return 'HOY';
    }

    if (dias === 1) {
      return 'MANANA';
    }

    if (dias <= 7) {
      return 'PROXIMO';
    }

    return 'PROGRAMADO';
  }


   private diasHastaCumpleanos(persona: PropietarioCumpleanos): number {
    const nacimiento = this.fechaNacimiento(persona);

    if (!nacimiento) {
      return 999999;
    }

    const hoy = this.inicioDelDia(new Date());
    let anio = hoy.getFullYear();

    let proximo = this.crearFechaCumpleanos(
      anio,
      nacimiento.getMonth(),
      nacimiento.getDate()
    );

    if (proximo.getTime() < hoy.getTime()) {
      anio++;
      proximo = this.crearFechaCumpleanos(
        anio,
        nacimiento.getMonth(),
        nacimiento.getDate()
      );
    }

    return Math.round(
      (proximo.getTime() - hoy.getTime()) / 86400000
    );
  }

  /*
   * Trata el 29 de febrero en años no bisiestos como el 28 de febrero.
   * Si tu organización usa otra regla, ajusta esta función.
   */
  private crearFechaCumpleanos(
    anio: number,
    mes: number,
    dia: number
  ): Date {
    if (mes === 1 && dia === 29 && !this.esBisiesto(anio)) {
      return new Date(anio, 1, 28);
    }

    return new Date(anio, mes, dia);
  }

  private esBisiesto(anio: number): boolean {
    return anio % 400 === 0 || (anio % 4 === 0 && anio % 100 !== 0);
  }

  private inicioDelDia(fecha: Date): Date {
    return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
  }

  private fechaNacimiento(
    persona: PropietarioCumpleanos
  ): Date | null {
    const valor = persona.fechanace;

    if (!valor) {
      return null;
    }

    // Evita desfases de zona horaria al recibir fechas YYYY-MM-DD.
    if (typeof valor === 'string') {
      const coincidencia = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor);

      if (coincidencia) {
        const anio = Number(coincidencia[1]);
        const mes = Number(coincidencia[2]);
        const dia = Number(coincidencia[3]);
        const fecha = new Date(anio, mes - 1, dia);

        if (
          fecha.getFullYear() !== anio ||
          fecha.getMonth() !== mes - 1 ||
          fecha.getDate() !== dia
        ) {
          return null;
        }

        return fecha;
      }

      // Formato habitual colombiano dd/MM/yyyy.
      const colombiana = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(valor);

      if (colombiana) {
        const dia = Number(colombiana[1]);
        const mes = Number(colombiana[2]);
        const anio = Number(colombiana[3]);
        const fecha = new Date(anio, mes - 1, dia);

        if (
          fecha.getFullYear() !== anio ||
          fecha.getMonth() !== mes - 1 ||
          fecha.getDate() !== dia
        ) {
          return null;
        }

        return fecha;
      }
    }

    const fecha = valor instanceof Date ? valor : new Date(valor);

    if (Number.isNaN(fecha.getTime())) {
      return null;
    }

    return new Date(
      fecha.getFullYear(),
      fecha.getMonth(),
      fecha.getDate()
    );
  }

  nombreCompleto(persona: PropietarioCumpleanos): string {
    return [
      persona.primernombre,
      persona.segundonombre,
      persona.papellidos,
      persona.seapellidos
    ]
      .filter(nombre => !!nombre?.trim())
      .join(' ');
  }

  iniciales(persona: PropietarioCumpleanos): string {
    return this.nombreCompleto(persona)
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(nombre => nombre.charAt(0).toUpperCase())
      .join('');
  }

  private normalizar(valor: string): string {
    return (valor ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  trackByCedula(
    index: number,
    persona: PropietarioCumpleanos
  ): string | number {
    return persona.cedula ?? index;
  }

  
iconoOrden(columna: string): string {
  if (this.sortColumn !== columna) {
    return 'fa-sort';
  }

  return this.sortDirection === 'asc'
    ? 'fa-sort-up'
    : 'fa-sort-down';
}


calcularResumen(): void {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const manana = new Date(hoy);
  manana.setDate(manana.getDate() + 1);

  const mesActual = hoy.getMonth();

  let cumpleanosHoy = 0;
  let cumpleanosManana = 0;
  let cumpleanosMes = 0;

  for (const propietario of this.propietarios ?? []) {
    const fecha = this.parseFechaNacimiento(
      propietario.fechaNacimiento ?? propietario.fechanace
    );

    if (!fecha) {
      continue;
    }

    const mesNacimiento = fecha.getMonth();
    const diaNacimiento = fecha.getDate();

    // Cumpleaños de hoy
    if (
      mesNacimiento === hoy.getMonth() &&
      diaNacimiento === hoy.getDate()
    ) {
      cumpleanosHoy++;
    }

    // Cumpleaños de mañana
    if (
      mesNacimiento === manana.getMonth() &&
      diaNacimiento === manana.getDate()
    ) {
      cumpleanosManana++;
    }

    // Cumpleaños del mes actual
    if (mesNacimiento === mesActual) {
      cumpleanosMes++;
    }
  }

  this.resumen = {
    hoy: cumpleanosHoy,
    manana: cumpleanosManana,
    mes: cumpleanosMes,
    total: (this.propietarios ?? []).length
  };

 // console.log(this.resumen);  
}


private ordenarResultados(): void {
  const factor = this.sortDirection === 'asc' ? 1 : -1;

  this.filteredTableItems.sort((a, b) => {
    // Ordenar por la próxima fecha de cumpleaños
    if (this.sortColumn === 'proximo') {
      const diferencia =
        this.diasHastaCumpleanos(a) - this.diasHastaCumpleanos(b);

      // Si las fechas coinciden, ordenar por nombre.
      return diferencia !== 0
        ? diferencia * factor
        : this.nombreCompleto(a).localeCompare(
            this.nombreCompleto(b),
            'es',
            { sensitivity: 'base' }
          );
    }

    let resultado = 0;

    switch (this.sortColumn) {
      case 'cedula':
        resultado = String(a.cedula ?? '').localeCompare(
          String(b.cedula ?? ''),
          'es',
          { numeric: true }
        );
        break;

      case 'primernombre':
        resultado = this.nombreCompleto(a).localeCompare(
          this.nombreCompleto(b),
          'es',
          { sensitivity: 'base' }
        );
        break;

      case 'fechanace': {
        const fechaA = this.parseFechaNacimiento(
          a.fechaNacimiento ?? a.fechanace
        );
        const fechaB = this.parseFechaNacimiento(
          b.fechaNacimiento ?? b.fechanace
        );

        resultado =
          (fechaA?.getTime() ?? 0) - (fechaB?.getTime() ?? 0);
        break;
      }

      case 'edad':
        resultado = (a.edad ?? -1) - (b.edad ?? -1);
        break;
    }

    return resultado * factor;
  });
}

}

  

